import React, { useEffect, useState } from "react";
import { useTabs } from "../hooks/useTabs";
import Spin from "../ui/Spin";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Button from "../ui/Button";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import Float from "../ui/Float";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { getSaved, kbdEvent, moveItem } from "../utils/Utils";
import DateInput from "../ui/DateInput";
import SelectBox from "../ui/SelectBox";
import { ENUMS } from "../utils/Enums";
import { ROUTES } from "../utils/Routes";
import { createScreen } from "../hooks/createScreen";
import CustomersController from "../controllers/CustomersController";
import { getSignal } from "../App";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import POSSearchResults from "./POSSearchResults";

export default function POSSearch(props) {

    const { controller = "", route = "", callback = () => { } } = props;
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState([])
    const [selected, setSelected] = useState({});
    const [align, setAlign] = useState("auto");
    const [query, setQuery] = useState({
        value: "",
        offset: 0
    })
    let _saved = getSaved("pos_search");
    const buffer = 10;
    const row_key = "posh_id"

    const [search, setSearch] = useState((_saved) ? _saved : {
        log: "O",
        section: "C",
        section_filter: "",
        date: "",
        date_filter: "",
        invoice: "",
        isbn: "",
        customer: "",
        cust_po: "",
        finalize: ""
    })

    const defaultTabs = [
        { label: "log", key: "log", value: search.log },
        { label: "section", key: "section", value: search.section },
        { label: "section_filter", key: "section_filter", value: "" },
        { label: "date", key: "date", value: "" },
        { label: "date_filter", key: "date_filter", value: "" },
        { label: "invoice", key: "invoice", value: "" },
        { label: "isbn", key: "isbn", value: "" },
        { label: "customer", key: "customer", value: "" },
        { label: "cust_po", key: "cust_po", value: "" },
        { label: "finalize", key: "finalize", value: "" },
    ]

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "log");



    const blurField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.blur === 'function') {
            el.blur();
        }
    }

    const focusField = (_field = index) => {
        const el = refs.current[_field];
        if (el && typeof el.focus === 'function') {
            el.focus();
        }
    }

    useEffect(focusField, [index])





    const nextRow = (_rows = 1) => {
        moveItem({ data: results?.rows, selected, setSelected, row_key: "posh_id", step: _rows, setAlign, alignOnMove: false })
    };
    const prevRow = (_rows = 1) => {
        moveItem({ data: results?.rows, selected, setSelected, row_key: "posh_id", step: -_rows, setAlign, alignOnMove: true })
    };



    const status = {
        log: "Choose by letter/number of the Log group to view",
        section: "Search for [H]eld [C]urrent [L]og loc[K]ed [M]ine [O]nline [P]repay [Q]uote  ",
        section_filter: "[A]dj [S]mry [R]trn [V]oid {amount} {tender} {cust po} {disc %20 or %} ",
        date: "Enter a starting date (listed then by invoice # ",
        date_filter: "[A]dj [S]mry [R]trn [V]oid {amount} {tender} {cust po} {disc %20 or %} ",
        invoice: "",
        isbn: "",
        customer: "Name, phone or account#",
        cust_po: "Customer PO# (blank to find latest online 'OL' PO)",
        finalize: "Finalize a group of PrpyRdm transactions (ISBN optional). ",
    }


    useEffect(() => {


        if (loading) {
            return;
        }

        const actions = [
            { key: KBD.ARROW_DOWN, action: (e) => { next() } },
            { key: KBD.ARROW_UP, action: (e) => { prev() } },
            { key: KBD.TAB, action: (e) => { next() } },
            { key: KBD.SHIFT_TAB, action: (e) => { prev() } },
            { key: KBD.ESCAPE, action: (e) => { callback(false) } },


        ];
        const cleanup = listen(controller, route, actions, false, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.LEFT_BRACKET, KBD.TAB, KBD.SHIFT_TAB, KBD.ESCAPE, KBD.ENTER, KBD.CTRL_ENTER, KBD.PAGE_UP, KBD.PAGE_DOWN, KBD.ALT_S, KBD.ALT_H, KBD.ALT_L]);
        return cleanup;
    }, [search, index, loading]);



    const statuses = [
        { value: "O", label: "New Online - Rcvd online order", color: "var(--text)" },
        { value: "A", label: "NotifyCust - Ready for pick up", color: "var(--text-green)" },
        { value: "R", label: "ReadyToShp - Picked (locked)", color: "var(--text-olive)" },
        { value: "K", label: "SOSwaiting - Wait until PubDate", color: "var(--text-blue)" },
        { value: "I", label: "MoreToCome - Notify when next rcv", color: "var(--text-teal)" },
        { value: "J", label: "WaitForAll - Notify once complete", color: "var(--text-teal)" },
        { value: "Q", label: "Reserved   - Customer request", color: "var(--text-light)" },
        { value: "X", label: "TextNotice - Customer notified", color: "var(--text-light)" },
        { value: "E", label: "Eml Notice - Customer notified", color: "var(--text-light)" },
        { value: "N", label: "Phoned     - Customer notified", color: "var(--text-light)" },
        { value: "V", label: "VoiceMsg   - Customer notified", color: "var(--text-light)" },
        { value: "Z", label: "Don't call - Don't contact cust", color: "var(--text-light)" },
        { value: "C", label: "CustReply  - Customer responded", color: "var(--text-light)" },
        { value: "S", label: "Shipped    - Completed", color: "var(--text-dim)" },
        { value: "T", label: "Done/taken - Completed", color: "var(--text-dim)" },
        { value: "<", label: "All by date- from oldest", color: "var(--text-light)" },
        { value: ">", label: "All by date- from newest", color: "var(--text-light)" }
    ];



    const selectCustomer = (_search = "", initData = [], newCustomer = false) => {
        window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER;
        blurField("customer");
        createScreen({
            signal: getSignal(),
            component: <CustomersController controller={controller} is_modal initData={initData} newCustomer={newCustomer} search={_search} route={ROUTES.CUSTOMER.CUSTOMER} />, closable: false, title: "Select Customer",
            callback: (_obj) => {
                if (_obj) {
                    runSearch(_obj?.person_id)
                } else {
                    focusField("customer");
                }
            }
        });
    }


    const runSearch = (_value, _offset = 0) => {

        let _api = "";

        let _filters = { limit: 40, offset: _offset };

        switch (index) {

            case "log":
                _api = "point_of_sale.searchLog";
                _filters.status_type = _value;
                break;

            case "section":
            case "section_filter":
                _api = "point_of_sale.searchSection";
                _filters.section_character = getVal("section");
                _filters.filter = getVal("section_filter");
                break;
            default:

                break;
        }
        setLoading(true);
        pubCall(_api, { ..._filters }, (_s, _r) => {
            if (_s) {
                if (_r?.rows.length === 0) {
                    if (!_offset) {
                        showError({ error: "No Results" })
                    }
                }
                if (_offset) {
                    setResults({ ...results, rows: [...results.rows].concat(_r?.rows) });
                } else {
                    setResults(_r);
                    setSelected(_r?.rows?.[0] || "")
                }
            } else {
                showError(_r);
            }
            setLoading(false)
        })
        // searchCustomer ()
        // searchPrimaryCondition (ISBN)

    }


    useEffect(() => {
        if (query?.value) {
            runSearch(query?.value, query?.offset)
        }
    }, [query])

    useEffect(() => {
        if (!results?.rows || loading || !selected?.[row_key]) return;
        const index = results.rows.findIndex(item => item[row_key] === selected[row_key]);
        if (index === -1) return;
        const isNearEnd = index > results.rows.length - buffer;
        const canLoadMore = results.total && (query.offset + results.rows.length) < results.total;

        if (isNearEnd && canLoadMore) {
            setQuery(prev => ({
                ...prev,
                offset: prev.offset + 40
            }));
        }

    }, [selected, results, query.offset, loading, row_key]);

    useEffect(() => {
        if (results?.rows?.length) {
            window.bm_state.value = ROUTES.POS.SEARCH_RESULTS
        } else {
            window.bm_state.value = ROUTES.POS.SEARCH;
        }
    }, [results?.rows])

    if (results?.rows?.length) {
        return (
            <>
                <POSSearchResults
                    type={index}
                    controller={controller}
                    route={ROUTES.POS.SEARCH_RESULTS}
                    results={results}
                    selected={selected}
                    setSelected={setSelected}
                    align={align}
                    setAlign={setAlign}
                    next={nextRow}
                    prev={prevRow}
                    query={query}
                    setQuery={setQuery}
                    callback={(_e) => {
                        if (_e) {
                            callback(_e)
                        }
                    }} />
            </>
        )
    }


    return (

        <Spin style={{ "margin": "0px -10px" }} loading={loading}>

            <div style={{ "width": "570px", "padding": "0px 10px" }}>

                <Float>
                    <div>
                        <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
                        <Space height={25} size={10}>
                            <Label className={(index === "log") ? "selected" : ""} width={100}>Log</Label>

                            <SelectBox
                                openOnPageUp
                                {...editProps("log")}
                                edit={(index === "log")}
                                className={(index === "log") ? "" : "dim"}
                                allowKeys
                                keyfield="value"
                                width={376}
                                onPageDown={(e) => setQuery({ ...query, "value": e, offset: 0 })}
                                onEnter={() => next()}
                                options={statuses}
                                onClick={() => setIndex("log")}
                            />

                            {/* <Input uppercase maxLength={1} width={20} style={{ "textAlign": "center" }} className={(index === "log") ? "" : "dim"} {...editProps("log")} edit={(index === "log")} /> */}
                        </Space>
                        <div className="shim" /><div className="shim" />

                        <Space height={25} size={10}>
                            <Label className={(index === "section") ? "selected" : ""} width={100}>Section</Label>
                            {/* <Input maxLength={1} chars={["H", "C", "L", "K", "M", "O"]} uppercase width={20} style={{ "textAlign": "center" }} className={(index === "section") ? "" : "dim"} {...editProps("section")} edit={(index === "section")} /> */}

                            <SelectBox
                                openOnPageUp
                                {...editProps("section")}
                                edit={(index === "section")}
                                className={(index === "section") ? "" : "dim"}
                                allowKeys
                                keyfield="value"
                                width={95}
                                onPageDown={(e) => setQuery({ ...query, "value": e, offset: 0 })}
                                onEnter={() => next()}
                                options={ENUMS.POS_SEARCH_SECTIONS}
                                onClick={() => setIndex("section")}
                            />


                            <Label className={(index === 0) ? "section" : ""} >Filter</Label>
                            <Input onEnter={() => next()} width={220} className={(index === "section_filter") ? "" : "dim"} {...editProps("section_filter")} edit={(index === "section_filter")} onClick={() => setIndex("section_filter")} />
                        </Space>
                        <div className="shim" /><div className="shim" />

                        <Space height={25} size={10}>
                            <Label className={(index === "date") ? "selected" : ""} width={100}>Date</Label>
                            <DateInput onEnter={() => next()} onFilled={() => next()} className={(index === "date") ? "" : "dim"} {...editProps("date")} edit={(index === "date")} onClick={() => setIndex("date")} />
                            <Label className={(index === 0) ? "date_filter" : ""} >Filter</Label>
                            <Input onEnter={() => next()} width={220} className={(index === "date_filter") ? "" : "dim"} {...editProps("date_filter")} edit={(index === "date_filter")} onClick={() => setIndex("date_filter")} />
                        </Space>
                        <div className="shim" /><div className="shim" />

                        <Space height={25} size={10}>
                            <Label className={(index === "invoice") ? "selected" : ""} width={100}>Invoice</Label>
                            <Input onEnter={() => next()} uppercase maxLength={6} width={95} className={(index === "invoice") ? "" : "dim"} {...editProps("invoice")} edit={(index === "invoice")} />
                        </Space>
                        <div className="shim" /><div className="shim" />

                        <Space height={25} size={10}>
                            <Label className={(index === "isbn") ? "selected" : ""} width={100}>ISBN</Label>
                            <Input onEnter={() => next()} uppercase maxLength={13} width={195} className={(index === "isbn") ? "" : "dim"} {...editProps("isbn")} edit={(index === "isbn")} />
                        </Space>
                        <div className="shim" /><div className="shim" />

                        <Space height={25} size={10}>
                            <Label className={(index === "customer") ? "selected" : ""} width={100}>Customer</Label>




                            <Input onEnter={() => next()} width={376} className={(index === "customer") ? "" : "dim"} {...editProps("customer")} edit={(index === "customer")} onPageDown={(e) => selectCustomer(e)} />
                        </Space>
                        <div className="shim" /><div className="shim" />

                        <Space height={25} size={10}>
                            <Label className={(index === "cust_po") ? "selected" : ""} width={100}>Cust PO</Label>
                            <Input onEnter={() => next()} uppercase maxLength={10} width={195} className={(index === "cust_po") ? "" : "dim"} {...editProps("cust_po")} edit={(index === "cust_po")} />
                        </Space>
                        <div className="shim" /><div className="shim" />

                        <Space height={25} size={10}>
                            <Label className={(index === "finalize") ? "selected" : ""} width={100}>Finalize</Label>
                            <Input onEnter={() => next()} uppercase maxLength={13} width={195} className={(index === "finalize") ? "" : "dim"} {...editProps("finalize")} edit={(index === "finalize")} />
                            <Label>(Held PrpyRdms)</Label>
                        </Space>
                        <div className="shim" /><div className="shim" />
                        <div className="shim" /><div className="shim" />
                        <div className="shim" /><div className="shim" />
                    </div>

                </Float>


                <div style={{ "backgroundColor": "var(--console-bg)", "margin": "-10px -10px", "borderTop": "2px solid var(--border-secondary)", "padding": "10px" }}>
                    <div className="shim" />

                    <div style={{ "padding": "0px 10px" }}>
                        <Float>
                            <div>&nbsp;</div>
                            <Button onClick={() => kbdEvent(KBD.ENTER)} type="primary">Search</Button>
                        </Float>

                    </div>


                    <div className="shim" /><div className="shim" /><div className="shim" />
                    <Status><InfoIcon /> {status[index]}</Status>
                </div>



            </div>
        </Spin>


    )
}